import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let id = localStorage.getItem("visitor_id");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("visitor_id", id);
  }
  return id;
}

// Καταγράφει μία επίσκεψη ανά session (εξαιρεί το /admin), με σταθερό visitor_id.
export function usePageView() {
  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith("/admin")) return;
    if (sessionStorage.getItem("pv_tracked")) return;
    sessionStorage.setItem("pv_tracked", "1");
    axios.post(`${API}/track`, { path, visitor_id: getVisitorId() }).catch(() => {});
  }, []);
}
